// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Nu9S","notes":"Notes_notes__30pt8","note":"Notes_note__3MFW8","markdown":"Notes_markdown__QbP55"};